import { MenuPoint, MenuPointCallbackAction } from '@agilox/ui-common';
import { MenuPointUrl } from './enums/menupoint-url.enum';

export const selfTestMenuPoints = {
	tests: {
		name: 'general.menu.dashboard',
		url: MenuPointUrl.tests,
		icon: 'dashboard',
		roles: [],
	} as MenuPoint,
	logout: {
		name: 'general.logout',
		url: '',
		icon: 'logout',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.LOGOUT,
	} as MenuPoint,
};
